import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as IconArrowLeft } from '../../NewIcon/IconArrowLeft.svg';

const GlobalBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/main') {
    return null;
  }

  const handleBack = () => {
    const returnTo = location.state?.returnTo;
    if (typeof returnTo === 'string' && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
      navigate(returnTo, { replace: true });
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/main', { replace: true });
  };

  return (
    <div className="sticky top-4 z-30 mb-4 flex justify-end sm:justify-start">
      <button
        type="button"
        onClick={handleBack}
        className="inline-flex h-11 w-11 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-700 shadow-sm transition-colors duration-150 hover:border-[#005AE0] hover:bg-[#F8FAFF] hover:text-[#005AE0] focus:outline-none focus:ring-2 focus:ring-[#005AE0]/25"
        aria-label={`Înapoi de pe ${location.pathname}`}
        title="Înapoi"
      >
        <IconArrowLeft className="h-[18px] w-[18px]" aria-hidden="true" />
      </button>
    </div>
  );
};

export default GlobalBackButton;
